import type { VendorType } from "@/features/vendors/types";
import {
  ADDRESS_TYPES,
  GST_TREATMENTS,
  PAYMENT_TERMS,
  formatMoney,
  labelFor,
} from "@/features/clients/constants";

export { ADDRESS_TYPES, GST_TREATMENTS, PAYMENT_TERMS, formatMoney, labelFor };

export const VENDOR_TYPES: { value: VendorType; label: string }[] = [
  { value: "coil", label: "Coil" },
  { value: "sheet", label: "Sheet / plate" },
  { value: "pipe", label: "Pipe / tube inputs" },
  { value: "scrap", label: "Scrap" },
  { value: "services", label: "Services" },
  { value: "other", label: "Other" },
];
